export default __webpack_public_path__ + "static/media/key_features_convenient_stores.37edff93.png";